import React, { useState, useEffect, useMemo } from "react";
import { HiCheckCircle, HiOutlineCheckCircle } from "react-icons/hi";
import { FiCalendar, FiMail, FiPhone } from "react-icons/fi";
import { BsCalendarMonth, BsGenderAmbiguous } from "react-icons/bs";
import { RiFileGifFill } from "react-icons/ri";
import { LuCalendarDays } from "react-icons/lu";
import moment from "moment";
import { toast } from "react-hot-toast";
import bookingApi from "../../api/booking/BookingApi";
import Loading from "../../Util/Loading";
import { Link, useParams } from "react-router-dom";
import Layout from "../../Layout";
import { IoArrowBackOutline } from "react-icons/io5";
import staffApi from "../../api/staff/staff.api";
import CustomersCard from "../Dashboad/CustomerCard";
import userApi from "../../api/user/user.api";
import { BiTime } from "react-icons/bi";
import { MdOutlineCalendarMonth } from "react-icons/md";

function ListofCustomers() {
  const [isLoading, setIsLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const getAllCustomers = async () => {
    try {
      const { response, err } = await userApi.getAllUsers();

      if (response && response.data) {
        setCustomers(response.data);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await Promise.all([getAllCustomers()]);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  if (isLoading) return <Loading />;

  return (
    <Layout>
      <div className="flex items-center gap-4 mb-8">
        <Link
          to="/"
          className="bg-subMain border border-subMain border-dashed rounded-lg py-3 px-4 text-md"
        >
          <IoArrowBackOutline />
        </Link>
        <h2 className="capitalize  font-semibold text-subMain">
          List of customers
        </h2>
      </div>

      {/* boxes */}

      <div className="flex-colo gap-6 w-full text-white mt-4">
        <CustomersCard customers={customers} />
      </div>
    </Layout>
  );
}

export default ListofCustomers;
